<template>
  <div class="flex flex-col gap-3">
    <div v-for="filter in visibleAgeBrackets" :key="filter.key" class="flex items-center gap-1">
      <LazyFrontendServiceFilterToggleableToggle v-if="toggleable" :filter-id="filter.filterId" />
      <UCheckbox
        v-model="selectedAgeBrackets.value[filter.key]"
        :label="filter.label"
        :ui="{ label: 'font-light' }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const store = useServiceSearchStore()
const { selectedAgeBrackets, filters } = store
const { disabledFilters } = storeToRefs(store)
const { ageBrackets, selectedAgeRange } = useAgeBrackets(true)

const props = defineProps({
  toggleable: Boolean
})

// Filter out age brackets that are disabled in iframe settings
const visibleAgeBrackets = computed(() => {
  if (props.toggleable) return ageBrackets
  const disabled = disabledFilters.value || []
  return ageBrackets.filter((ageBracket) => !disabled.includes(ageBracket.filterId))
})

const watching = ref(false)

watch(
  selectedAgeRange,
  ({ min, max }) => {
    // if the range changes, update the store
    if (watching.value) return
    watching.value = true
    filters.ageRange = [min, max]
    nextTick(() => {
      watching.value = false
    })
  },
  { deep: true, immediate: true }
)

watch(
  () => filters.ageRange,
  (newAgeRange) => {
    // if the range changes, reset the selected age brackets
    if (watching.value) return
    watching.value = true
    const [min, max] = newAgeRange

    ageBrackets.forEach((ageBracket) => {
      const { key } = ageBracket
      // if the agebracket range includes the selected range, then select it
      selectedAgeBrackets.value[key] = ageBracket.min >= min && ageBracket.max <= max
    })

    // if they're all selected, don't show them as selected
    if (Object.values(selectedAgeBrackets.value).every((v) => v)) {
      Object.keys(selectedAgeBrackets.value).forEach((key) => {
        selectedAgeBrackets.value[key] = false
      })
    }

    nextTick(() => {
      watching.value = false
    })
  },
  { deep: true, immediate: true }
)
</script>
